import React, { useState } from "react";
import { ArrowRight, Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { createCheckout } from "@/lib/api";
import { cn } from "@/lib/utils";

export const CheckoutButton = ({ payload, className, testId, children, variant = "lime" }) => {
  const [loading, setLoading] = useState(false);
  const go = async () => {
    setLoading(true);
    try {
      const { checkout_url } = await createCheckout({ ...payload, origin_url: window.location.origin });
      window.location.assign(checkout_url);
    } catch (e) {
      toast.error("Couldn't start checkout — please try again or contact sales@fixlr.io");
      setLoading(false);
    }
  };
  return (
    <button type="button" onClick={go} disabled={loading} data-testid={testId} className={cn(variant === "lime" ? "btn-lime" : variant === "blue" ? "btn-blue" : "btn-ghost", "disabled:opacity-70", className)}>
      {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-3.5 w-3.5 opacity-70" />}
      {children}
      {!loading && <ArrowRight className="h-4 w-4" />}
    </button>
  );
};
